import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeChecker } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'

/**
 * Determines if the user is eligible for a check-in in the zone they have just
 * switched to
 */
export const checkIfEligibleForDailyCheckInOnZoneChange = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    meFeature.contexts.selectors.zoneContext.asObservable.pipe(
      rxjs.filter(TypeChecker.isNotNullish.raw),
      rxjs.map(() =>
        feature.actions.checkIfEligibleForDailyCheckIn
          .from('checkIfEligibleForDailyCheckInOnZoneChange')
          .create(),
      ),
    ),
)
